import React from 'react';
import { Column } from '@dls/web';
import { StyledRow, StyledText } from './styles';
import {IFooter} from './models/FooterModel';
import { v4 as uuid } from 'uuid';

const Footer = ({ copyrightText, menuItems, isMobileView }:IFooter) => {
  const renderMenu = () => {
    return menuItems?.map((item) => (
      <div data-testid="footer-menu-item" key={uuid()} onClick={item.onClick}>
        <StyledText type="smallBody">{item.text}</StyledText>
      </div>
    ));
  };

  return (
    <StyledRow
      data-testid="footer"
      middle="xs"
      between="xs"
      isMobileView={isMobileView}
    >
      {!isMobileView && <Column>{renderMenu()}</Column>}
      <Column>
        <StyledText type="smallBody">{copyrightText}</StyledText>
      </Column>
    </StyledRow>
  );
};

export default Footer;
